const headerAnimation = () => {
  const header = document.querySelector(".header-content-container");
  const colorSection = document.querySelectorAll("[data-header-color]");

  if (!header || colorSection.length === 0) return;

  colorSection.forEach((section) => {
    const getColor = section.dataset.headerColor;
    gsap.to(header, {
      scrollTrigger: {
        trigger: section,
        start: "top 10%",
        end: "bottom 10%",
        onEnter: () => updateHeaderClass(header, getColor),
        onEnterBack: () => updateHeaderClass(header, getColor),
      },
    });
  });

  const updateHeaderClass = (header, color) => {
    if (!header) return;

    header.classList.forEach((cls) => {
      if (cls.startsWith("header-") && cls !== "header-content-container") {
        header.classList.remove(cls);
      }
    });

    header.classList.add(`header-${color}`);
  };
};

export default headerAnimation;
